// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-1MiEQGEB clearfix","box_l":"box_l-aXo-mC0R","box_r":"box_r-2UxcuMbu"};